export default "__VITE_ASSET__bd74351c__"